import * as React from "react";

const ChevronDown: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5029 9.54277C15.8934 9.15241 16.6124 9.15241 17.0029 9.54277C17.3934 9.93313 17.3934 10.6518 17.0029 11.0421L12.0029 16.04L7.00289 11.0421C6.61237 10.6518 6.61237 9.93313 7.00289 9.54277C7.39342 9.15241 8.11237 9.15241 8.50289 9.54277L12.0029 13.0413L15.5029 9.54277Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronDown);
